import {ScanRepository} from '../repositories/ScanRepository';
import {Delivery, CreateDeliveryRequest} from '../entities/Delivery';

export class CreateDeliveryUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(request: CreateDeliveryRequest): Promise<Delivery> {
    // Validate request
    if (request.assignmentId <= 0) {
      throw new Error('Assignment ID must be greater than 0');
    }
    if (request.benefitId <= 0) {
      throw new Error('Benefit ID must be greater than 0');
    }
    if (request.caseUserId <= 0) {
      throw new Error('Case User ID must be greater than 0');
    }
    if (request.deliveryAmount <= 0) {
      throw new Error('Delivery amount must be greater than 0');
    }

    return await this.scanRepository.createDelivery(request);
  }
}
